export default "__VITE_ASSET__B9ySILSQ__"